import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  Inject,
  OnDestroy,
  Output,
  PLATFORM_ID,
} from '@angular/core';
import { WINDOW } from '@wizbii/angular-utilities';

@Directive({
  selector: '[appScrollSpy]',
})
export class ScrollSpyDirective implements AfterViewInit, OnDestroy {
  @Output('appScrollSpyScrolledPast') scrolledPast = new EventEmitter<boolean>();

  hidden = false;
  observer: IntersectionObserver;

  constructor(
    @Inject(WINDOW) private readonly window: any,
    private readonly elementRef: ElementRef,
    @Inject(PLATFORM_ID) private readonly platformId: Record<string, unknown>
  ) {}

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId) && 'IntersectionObserver' in this.window) {
      this.observer = new IntersectionObserver(this.intersectionCallback.bind(this));
      this.observer.observe(this.elementRef.nativeElement);
    }
  }

  intersectionCallback(entries: IntersectionObserverEntry[]): void {
    const entry = entries && entries[0];
    if (!entry) {
      return;
    }

    this.hidden = entry.intersectionRatio === 0 && entries[0].boundingClientRect.top < 0;
    this.scrolledPast.emit(this.hidden);
  }

  ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId) && this.observer) {
      this.observer.disconnect();
    }
  }
}
